import { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";

import { Option } from "@/@types/generics/Option";

import { SelectComponent } from "@/components/SelectComponent";
import { ObservationPatients } from "./ObservationPatients";
import { HospitalizedPatients } from "./HospitalizedPatients";
import { PatientsByCid } from "./PatientsByCid";
import { ReferralPatients } from "./ReferralPatients";
import { Card } from "react-bootstrap";
import { useLayout } from "@/../_metronic/layout/core";

export function GeneralPatients() {
	const { setTitle } = useLayout();
	const [selectedReportOption, setSelectedReportOption] = useState<number | undefined>();

	const reportOptions: Option<number>[] = [
		{ label: "Pacientes em observação", value: 1 },
		{ label: "Pacientes no internamento", value: 2 },
		{ label: "Pacientes atendidos por cid", value: 3 },
		{ label: "Pacientes transferidos", value: 4 },
	];

	function renderReportComponent(reportOption?: number) {
		switch (reportOption) {
			case 1:
				return <ObservationPatients />;
			case 2:
				return <HospitalizedPatients />;
			case 3:
				return <PatientsByCid />;
			case 4:
				return <ReferralPatients />;
		}
	}

	useEffect(() => {
		setTitle("Listagem - Pacientes");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="p-4">
			<Card className="h-100 shadow-sm">
				<Card.Body>
					<Row className="p-2">
						<Col>
							<InputGroup>
								<Form.Label>Tipo de relatório</Form.Label>
								<SelectComponent
									className="w-100"
									name="generalpatients"
									options={reportOptions}
									onChange={(event) =>
										Boolean((event as Option<string>).value)
											? setSelectedReportOption(
													Number((event as Option<string>).value)
											  )
											: setSelectedReportOption(undefined)
									}
									defaultValue={{ value: "", label: "Escolha uma opção" }}
									noOptionsMessage={() =>
										"nenhum resultado encontrado na pesquisa"
									}
								/>
							</InputGroup>
						</Col>
					</Row>
					{renderReportComponent(selectedReportOption)}
				</Card.Body>
			</Card>
		</div>
	);
}
